import { InjectionToken } from '@angular/core';

export const RESIZE_OBSERVER_CTOR = new InjectionToken<typeof ResizeObserver>('resize_observer_constructor', {
	providedIn: 'root',
	factory: () => ResizeObserver,
});
